import { IconCheck, IconPhoto, IconX } from '@tabler/icons-react-native';
import { PCImage } from 'app/design/primitives/image';
import { useTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { HubCard, HubCopy, HubEmoji, hubColors } from '../components';
import chair from '../assets/chair.png';
import hammer from '../assets/hammer.png';
import rake from '../assets/rake.png';
export function SwipeTutorialFace({ step, stackImage }: { step: number; stackImage?: string }) {
  const { t } = useTranslation('offer-hub');
  return (
    <HubCard stacked={step === 3 && Boolean(stackImage)} stackImage={stackImage}>
      <View style={{ width: '100%', alignItems: 'center', gap: step === 3 ? 16 : 40 }}>
        {step === 3 ? <HubEmoji>👏</HubEmoji> : <SwipeTutorialIllustration step={step} />}
        <HubCopy
          title={t(`swipeTutorial.${String(step)}.title`)}
          description={t(`swipeTutorial.${String(step)}.description`)}
        />
      </View>
    </HubCard>
  );
}

function SwipeTutorialIllustration({ step }: { step: number }) {
  const theme = useTheme();
  if (step === 0)
    return (
      <View
        style={{ width: 134, height: 100 }}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
      >
        <PCImage
          source={hammer}
          contentFit="contain"
          style={[swipeTutorialStyles.miniCard, { left: 0, top: 18, transform: [{ rotate: '-15deg' }] }]}
        />
        <PCImage
          source={chair}
          contentFit="cover"
          style={[swipeTutorialStyles.miniCard, { right: 0, top: 18, transform: [{ rotate: '15deg' }] }]}
        />
        <PCImage
          source={rake}
          contentFit="cover"
          style={[swipeTutorialStyles.miniCard, { left: 31, width: 72, height: 100, borderRadius: 12 }]}
        />
      </View>
    );
  const accept = step === 1;
  const Icon = accept ? IconCheck : IconX;
  return (
    <View
      style={{ width: 134, height: 105 }}
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <View
        style={[
          swipeTutorialStyles.demoCard,
          {
            width: 72,
            height: 88,
            top: 17,
            left: accept ? 6 : 58,
            backgroundColor: theme.colors['surface.tertiary-neutral'],
          },
        ]}
      >
        <IconPhoto size={32} color={theme.colors['icon.tertiary']} />
      </View>
      <View
        style={[
          swipeTutorialStyles.demoCard,
          {
            left: accept ? 48 : 0,
            backgroundColor: accept ? hubColors.teal : hubColors.error,
            transform: [{ rotate: accept ? '7.59deg' : '-7.59deg' }],
          },
        ]}
      >
        <Icon size={32} color="#FFFFFF" />
      </View>
    </View>
  );
}

export const swipeTutorialStyles = StyleSheet.create({
  nextCard: {
    position: 'absolute',
    top: -8,
    right: 16,
    bottom: 8,
    left: 16,
    zIndex: 0,
  },
  foregroundCard: { zIndex: 1 },
  miniCard: {
    position: 'absolute',
    width: 54,
    height: 75,
    borderRadius: 9,
    borderWidth: 0.75,
    borderColor: '#25252629',
    backgroundColor: '#FFFFFF',
    shadowColor: '#282725',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.16,
    shadowRadius: 3.5,
  },
  demoCard: {
    position: 'absolute',
    width: 80,
    height: 96,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#282725',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.16,
    shadowRadius: 3.5,
  },
});
